import { React, useEffect, useState, useRef } from "react";
import { Descriptions, Watermark, Image } from "antd";
import { useNavigate } from "react-router-dom";

import styles from "./index.module.css";
import Videox, { ERendererType } from "@ali/videox";
import { Demuxer } from "@ali/avx-format";
import { FLVParser } from "@ali/avx-format/cjs/parser/flv";
import { HLSParser } from "@ali/avx-format/cjs/parser/hls";
import { MP4Parser } from "@ali/avx-format/cjs/parser/mp4";

const Info = (props) => {
  // 按需引入
  const mp4Parser = new MP4Parser({ progressive: true });
  const flvParser = new FLVParser();
  const hlsParser = new HLSParser();

  const demuxer = new Demuxer({
    parsers: [mp4Parser, flvParser, hlsParser],
  });
  useEffect(() => {
    let dom = document.getElementById("videoElementHover-" + props.itemid);
    dom.innerHTML = "";
    if (dom) {
      const videox = new Videox({
        container: dom,
        src: props.itemsrc,
        demuxer,
        width: "100%",
        height: "100%",
        simd: true,
        live: true, //是否是直播源
        autoplay: true, //自动播放
        controls: false, //控制蓝
        loop: false, //循环播放
        muted: props.itemsong == props.itemid ? false : true, //是否静音//pc浏览器关掉首屏不会播放，需要打开
        poster: props.itemsrc, //封面图
        hardwareAcceleration: "prefer-hardware",
        objectFit: "contain", //视频尺寸和播放器尺寸匹配
        posterSize: "contain",
        playControl: true,
      });
      videox.play();

      console.log(videox.controller.options.muted, ",videox");
    }
  }, [props.itemsong, props.itemsrc, props.itemid]);

  return (
    <div
      id={"videoElementHover-" + props.itemid}
      style={{ width: "33%", height: "100%" }}
    ></div>
  );
};
export default Info;
